const heapify = (messages, newMessage) => {
    let findIndex = -1;
    const clonedMessages = [...messages];
    if (clonedMessages.length === 0) {
        clonedMessages.push(newMessage);
        return clonedMessages;
    }
    for (let i = 0; i < clonedMessages.length; i++) {
        const message = clonedMessages[i];
        if (message) {
            const currentMessageSequenceNo = (message.message.sequenceStartTime ?? 0) + message.message.sequence;
            const newMessageSequenceNo = (newMessage.message.sequenceStartTime ?? 0) + newMessage.message.sequence;
            if (currentMessageSequenceNo === newMessageSequenceNo) {
                return clonedMessages;
            }
            if (currentMessageSequenceNo > newMessageSequenceNo) {
                findIndex = i;
                break;
            }
        }
    }
    if (findIndex === -1) {
        clonedMessages.push(newMessage);
    }
    else {
        clonedMessages.splice(findIndex, 0, newMessage);
    }
    return clonedMessages;
};
export default heapify;
//# sourceMappingURL=heapify.js.map